<div class="menubar">
  @if (showMenubarLogo) {
    <div class="menubar-section">
      <tm-menubar-logo></tm-menubar-logo>
    </div>
    <div class="divider"></div>
  }
  <div class="menubar-section menu-buttons">
    <tm-registered-components-renderer [config]="config" area="menu"></tm-registered-components-renderer>
  </div>
  <div class="divider"></div>
  <div class="menubar-section">
    <tm-profile></tm-profile>
  </div>
</div>
